export var AssigneeType;
(function (AssigneeType) {
    AssigneeType["TECHNICIAN"] = "technician";
    AssigneeType["SUBCONTRACTOR"] = "subcontractor";
})(AssigneeType || (AssigneeType = {}));
